import {Component, Input, OnChanges} from '@angular/core';
import {StatusStyle} from '../../../../components/status/status.component';

export const MAX_LENGTH_TO_CROP = 31;

@Component({
    selector: 'af-info',
    templateUrl: 'info.component.html',
    styleUrls: ['info.component.scss'],
    standalone: false
})
export class InfoComponent implements OnChanges {
    @Input() info: DisplayRowItem[][] = [];

    ngOnChanges(): void {
        this.info = this.info.map(row => {
            return row.filter(item => item.show !== false);
        });
    }
}

export interface DisplayRowItem {
    type: DisplayType;
    label: string;
    value?: any;
    statusStyle?: StatusStyle;
    show?: boolean;
    span?: number;
    cropText?: boolean;
}

export declare type DisplayType = 'text' | 'money' | 'date-time' | 'status' | 'priority';
